import {__VOYAGER__, __VOYAGERX__} from './../../../config/api-config';

export function prepareDetailsPageStaticDataCall(
  vhid,
  filter = {},
  fields = '',
) {
  if (!vhid) {
    return '';
  }
  const {hctx = ''} = filter;
  const context = hctx ? `&context=["${hctx}"]` : '';
  const field = fields ? `&fields=["${fields}"]` : '';
  // ! share with Voyager team that v3 flavour is not being supported for Detail static data
  // flavour=v3&
  const url = `${__VOYAGERX__}/api/v2/hotels/get_hotels_static_data_v2/?tag=All&id=${vhid}${context}${field}`;
  return url;
}
